import request from '@/utils/http.js';
import { roomSubjectApiList } from '@/request/env';
import { getQueryString } from '@/utils/index.js';


// 通过活动id获取活动拥有者用户id
function subjectInitBefore(params) {
  const url = roomSubjectApiList['subjectInitBefore']['v3'];
  return request({
    url,
    method: 'POST',
    data: params,
    headers: {
      'gray-Id': getQueryString("grayId"),
      token: ''
    }
  });
}

// 获取专题详情信息
function getSubjectInfo(data = {}) {
  const url = roomSubjectApiList['getSubjectInfo']['v3'];
  return request({
    url,
    method: 'POST',
    data,
    headers: {
      token: ''
    }
  });
};


// 获取专题绑定的活动列表
function getWebinarList(data = {}) {
  const url = roomSubjectApiList['getWebinarList']['v3'];
  return request({
    url,
    method: 'POST',
    data
  });
};

// 专题初始化
function initSubjectInfo(params = {}) {
  const url = roomSubjectApiList['initSubjectInfo']['v3'];
  return request({
    url,
    method: 'Get',
    params
  });
};


// 专题鉴权
function getSubjectWatchAuth(data = {}) {
  const url = roomSubjectApiList['subjectWatchAuth']['v3'];
  return request({
    url,
    method: 'POST',
    data
  });
};
//获取当前用户报名的信息
function getAnswerInfo(data = {}) {
  const url = roomSubjectApiList['getAnswerInfo']['v3'];
  return request({
    url,
    method: 'POST',
    data
  });
}

function getRegWebinarList(data = {}) {
  const url = roomSubjectApiList['getRegWebinarList']['v3'];
  return request({
    url,
    method: 'POST',
    data
  });
}


export default {
  getSubjectInfo,
  getWebinarList,
  subjectInitBefore,
  getSubjectWatchAuth,
  initSubjectInfo,
  getAnswerInfo,
  getRegWebinarList
};